import ApiService from './api.service'
import { TokenService } from './storage.service'

const pubQuoteSearchService = {
    searchQuotesForSalesRep: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteSearch/SearchQuotesForSalesRep',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    searchQuotesForApproval: async () => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteSearch/SearchQuotesForApproval',
            data: null,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    getUserDefaultQuoteSearchCriteria: async () => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteSearch/GetUserDefaultQuoteSearchCriteria',
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    getUserDefaultQuoteSearchLookups: async () => {
        const requestData = {
            method: 'post',
            url: '/api/QuoteSearch/GetUserDefaultQuoteSearchLookups',
            data: {},
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
}

export default pubQuoteSearchService